/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Keyword_Optimizer_Generate_Cta_HintInputs */

const en_keyword_optimizer_generate_cta_hint = /** @type {(inputs: Keyword_Optimizer_Generate_Cta_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Next step: use AI to rewrite your existing bullets so they naturally include these keywords. Uses 1 credit.`)
};

const de_keyword_optimizer_generate_cta_hint = /** @type {(inputs: Keyword_Optimizer_Generate_Cta_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nächster Schritt: Lass die KI deine bestehenden Bullet Points so umschreiben, dass diese Keywords natürlich enthalten sind. Verbraucht 1 Credit.`)
};

const fr_keyword_optimizer_generate_cta_hint = /** @type {(inputs: Keyword_Optimizer_Generate_Cta_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Étape suivante : utilisez l'IA pour reformuler vos points existants en y intégrant naturellement ces mots-clés. Utilise 1 crédit.`)
};

const es_keyword_optimizer_generate_cta_hint = /** @type {(inputs: Keyword_Optimizer_Generate_Cta_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Próximo paso: usa la IA para reescribir tus viñetas existentes e incluir estas palabras clave de forma natural. Consume 1 crédito.`)
};

const it_keyword_optimizer_generate_cta_hint = /** @type {(inputs: Keyword_Optimizer_Generate_Cta_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prossimo passo: usa l'IA per riscrivere i tuoi bullet point in modo che includano naturalmente queste parole chiave. Usa 1 credito.`)
};

const nl_keyword_optimizer_generate_cta_hint = /** @type {(inputs: Keyword_Optimizer_Generate_Cta_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volgende stap: gebruik AI om je bestaande bullet points te herschrijven zodat deze zoekwoorden natuurlijk worden opgenomen. Kost 1 credit.`)
};

const pl_keyword_optimizer_generate_cta_hint = /** @type {(inputs: Keyword_Optimizer_Generate_Cta_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kolejny krok: niech AI przeredaguje Twoje istniejące punkty, aby naturalnie uwzględnić te słowa kluczowe. Zużywa 1 kredyt.`)
};

const fi_keyword_optimizer_generate_cta_hint = /** @type {(inputs: Keyword_Optimizer_Generate_Cta_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seuraava askel: anna tekoälyn kirjoittaa olemassa olevat kohdat uudelleen niin, että avainsanat sisällytetään luontevasti. Käyttää 1 krediitin.`)
};

const da_keyword_optimizer_generate_cta_hint = /** @type {(inputs: Keyword_Optimizer_Generate_Cta_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Næste skridt: brug AI til at omskrive dine eksisterende bullet points, så de naturligt indeholder disse nøgleord. Bruger 1 credit.`)
};

const sv_keyword_optimizer_generate_cta_hint = /** @type {(inputs: Keyword_Optimizer_Generate_Cta_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nästa steg: använd AI för att skriva om dina befintliga punkter så att dessa nyckelord inkluderas naturligt. Använder 1 credit.`)
};

/**
* | output |
* | --- |
* | "Next step: use AI to rewrite your existing bullets so they naturally include these keywords. Uses 1 credit." |
*
* @param {Keyword_Optimizer_Generate_Cta_HintInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const keyword_optimizer_generate_cta_hint = /** @type {((inputs?: Keyword_Optimizer_Generate_Cta_HintInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Keyword_Optimizer_Generate_Cta_HintInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_keyword_optimizer_generate_cta_hint(inputs)
	if (locale === "fr") return fr_keyword_optimizer_generate_cta_hint(inputs)
	if (locale === "es") return es_keyword_optimizer_generate_cta_hint(inputs)
	if (locale === "it") return it_keyword_optimizer_generate_cta_hint(inputs)
	if (locale === "nl") return nl_keyword_optimizer_generate_cta_hint(inputs)
	if (locale === "pl") return pl_keyword_optimizer_generate_cta_hint(inputs)
	if (locale === "fi") return fi_keyword_optimizer_generate_cta_hint(inputs)
	if (locale === "da") return da_keyword_optimizer_generate_cta_hint(inputs)
	if (locale === "sv") return sv_keyword_optimizer_generate_cta_hint(inputs)
	return en_keyword_optimizer_generate_cta_hint(inputs)
});